import { render } from "./SkillSuperAdmin.vue?vue&type=template&id=01444d88"
import script from "./SkillSuperAdmin.vue?vue&type=script&lang=js"
export * from "./SkillSuperAdmin.vue?vue&type=script&lang=js"

import "./SkillSuperAdmin.vue?vue&type=style&index=0&id=01444d88&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__